import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// The appointments that fold out under each proposal row. A module of its own
// rather than part of kandidatenvorschlagInline.js: the two share nothing but
// the table they are rendered into, and a Termin is addressed by its own id on
// its own sub-resource.
//
// Bound to the same delegated listeners on the same container, which is what
// makes the split free - neither module knows how many rows there are.

function reloadWith(key) {
  window.location.href = withFlash(window.location.pathname, key);
}

function fail(err, control) {
  hideLoading();
  if (control) control.disabled = false;
  notifyError(
    err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
  );
}

export function initTerminInline() {
  const liste = document.getElementById('kandidatenvorschlag-liste');
  if (!liste) return;

  const modal = document.getElementById('termin-modal');
  const form = document.getElementById('termin-form');

  // Which proposal the dialog is booking for. Set by the click that opens it,
  // the same way the Ablehnung dialog next door tracks its row.
  let offenerVorschlag = null;

  form?.querySelector('[data-action="abbrechen"]')?.addEventListener('click', () => modal.close());

  liste.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    if (button.dataset.action === 'termin-neu') {
      offenerVorschlag = button.closest('.vorschlag-termine')?.dataset.id || null;
      if (!offenerVorschlag) return;

      form.reset();
      modal.showModal();
      return;
    }

    if (button.dataset.action !== 'termin-loeschen') return;

    const zeile = button.closest('[data-termin-id]');
    const vorschlagId = button.closest('.vorschlag-termine')?.dataset.id;
    const terminId = zeile?.dataset.terminId;
    if (!vorschlagId || !terminId) return;

    const confirmed = await confirmAction({
      title: 'Termin entfernen',
      message: 'Möchten Sie diesen Termin endgültig entfernen?',
      okText: 'Entfernen'
    });
    if (!confirmed) return;

    button.disabled = true;
    showLoading('Termin wird entfernt …');

    try {
      await http.delete(`/kandidatenvorschlaege/${vorschlagId}/termine/${terminId}`);
      reloadWith('termin-entfernt');
    } catch (err) {
      fail(err, button);
    }
  });

  // Recording how an appointment went. The one field that changes after the fact,
  // so it saves on change rather than behind an edit button.
  liste.addEventListener('change', async (event) => {
    const select = event.target.closest('[data-role="ergebnis-select"]');
    if (!select) return;

    const zeile = select.closest('[data-termin-id]');
    const vorschlagId = select.closest('.vorschlag-termine')?.dataset.id;
    const terminId = zeile?.dataset.terminId;
    if (!vorschlagId || !terminId) return;

    select.disabled = true;
    showLoading('Wird gespeichert …');

    try {
      await http.patch(`/kandidatenvorschlaege/${vorschlagId}/termine/${terminId}`, {
        ergebnis: select.value
      });
      reloadWith('termin-aktualisiert');
    } catch (err) {
      fail(err, select);
    }
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!offenerVorschlag) return;

    const data = Object.fromEntries(new FormData(form).entries());
    const submitButton = form.querySelector('button[type="submit"]');

    if (submitButton) submitButton.disabled = true;
    showLoading('Wird gespeichert …');

    try {
      await http.post(`/kandidatenvorschlaege/${offenerVorschlag}/termine`, data);
      reloadWith('termin-erfasst');
    } catch (err) {
      fail(err, submitButton);
    }
  });
}
